// extracted by mini-css-extract-plugin
export default {"page-wrapper":"styles_page-wrapper__3G1ha","ssr-layout":"styles_ssr-layout__aRWfc","dashboardLayoutContainer":"styles_dashboardLayoutContainer__ETeRK"};